import * as React from 'react';
import { cn } from '@/lib/utils';

export interface GlassCardProps extends React.HTMLAttributes<HTMLDivElement> {
  /** Intensity of the blur effect */
  blur?: 'sm' | 'md' | 'lg';
  /** Whether to show a hover glow effect */
  glow?: boolean;
}

const blurMap = {
  sm: 'backdrop-blur-[6px]',
  md: 'backdrop-blur-[10px]',
  lg: 'backdrop-blur-[20px]',
} as const;

const GlassCard = React.forwardRef<HTMLDivElement, GlassCardProps>(
  ({ className, blur = 'md', glow = false, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(
          'rounded-lg border border-border/50 bg-card/80 p-6 shadow-md transition-all duration-200',
          blurMap[blur],
          glow && 'hover:glow-primary hover:border-primary/30',
          className
        )}
        {...props}
      />
    );
  }
);
GlassCard.displayName = 'GlassCard';

export { GlassCard };
